// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00b0b778","239":"fee2af72","553":"4f8c3b26"}[chunkId] + ".chunk.js";
};